import script from "./Observation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Observation.vue?vue&type=script&lang=ts&setup=true"

import "./Observation.vue?vue&type=style&index=0&id=a8c08a32&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8c08a32"]])

export default __exports__